module.exports = __webpack_public_path__ + "img/stackslash-93.045300c1.jpg";